import { config } from 'lib-shared-backend-config';

import { MicrophoneError } from 'utils/telephony/microphone';

/** The various microphone error messages. */
export const microphoneErrorMessages: Readonly<
  Record<MicrophoneError, string>
> = {
  PermissionDeniedError:
    'Permissions have not been granted to use your microphone, you need to allow access to your microphone in order to receive and make phone calls.',
  NotFoundError:
    'No microphone found, you need a microphone in order to receive and make phone calls.',
  AbortError:
    'Although permissions is granted by both the user and operating system to access the microphone, and no hardware issues occurred that would throw the NotReadableError exception, some problem occurred which prevented the microphone from being used. You need a working microphone in order to receive and make phone calls.',
  NotAllowedError:
    'Permissions have not been granted to use your microphone, you need to allow access to your microphone in order to receive and make phone calls.',
  SecurityError:
    'You need a working microphone in order to receive and make phone calls.',
  NotReadableError:
    'A hardware error occurred at the operating system or browser level which prevented access to the microphone. You need a working microphone in order to receive and make phone calls.',
  OverConstrainedError:
    'A hardware error occurred at the operating system or browser level which prevented access to the microphone. You need a working microphone in order to receive and make phone calls.',
};

/** The various solutions to microphone problems. */
export const microphoneErrorSolutionMessages: readonly {
  readonly title: string;
  readonly description: string;
}[] = [
  {
    title: 'The microphone is not connected',
    description:
      'Maybe your microphone is not connected to your computer, or not properly plugged in.',
  },
  {
    title: 'The microphone blocked',
    description: `The microphone is blocked by the browser. Try a to allow ${config.domain.web} to use the microphone in the browser microphone permission settings.`,
  },
  {
    title: 'The microphone cable is faulty',
    description: 'Try using a different cable.',
  },
  {
    title: 'Microphone is disabled in your OS',
    description:
      'The device may be working, but is disabled by the software in the operating system.',
  },
  {
    title: 'Microphone is used by another application',
    description:
      'If some other application is using your microphone, the device may not be available for Dixa.',
  },
  {
    title: 'The microphone is faulty',
    description: 'The microphone needs to be replaced. :(',
  },
];
